import { render, staticRenderFns } from "./NfeObservations.vue?vue&type=template&id=e3b1c97a"
import script from "./NfeObservations.vue?vue&type=script&lang=js"
export * from "./NfeObservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports